import React, { useState } from "react";
import styled from "styled-components";
import { Colors, Text } from "../../config";
import ValidityAccordion from "./ValidityAccordion";
import { useNavigate } from "react-router-dom";
import Disclaimer from "../../components/Disclaimer";
import UserAvatar from "../../components/UserAvatar";
import { useExtraFieldsContext } from "../../contexts/ExtraFieldsContext";
const arrowDown = require("../../assets/images/down-arrow-white.png");

const PlanAJourneyLeftContainer = ({ ticketValidityList, isDisclaimer }) => {
  let navigate = useNavigate();
  const { extraFields } = useExtraFieldsContext();
  const [showDisclaimer, setDisclaimer] = useState(true);
  const [showTicketList, setShowTicketList] = useState(true);
  const empData = JSON.parse(localStorage.getItem("employeeData"));
  if (!empData) {
    navigate("/auth/login");
  }
  const empName = empData?.firstName;
  return (
    <LeftContainer>
      <LeftContainerHeader>
        <UsernameAvatar>
          <UserAvatarContainer>
            <UserAvatar
              imgSrc={extraFields?.photo}
              userName={empData?.firstName + " " + empData?.lastName}
            />
          </UserAvatarContainer>
          <PassengerName>Hi {empName}</PassengerName>
        </UsernameAvatar>
        <PassengerWelcomeText>
          {Text.welcomeBackYourJourneyContinues}
        </PassengerWelcomeText>
        {isDisclaimer && showDisclaimer && (
          <LeftDisclaimer>
            <Disclaimer onClose={() => setDisclaimer(false)} />
          </LeftDisclaimer>
        )}
      </LeftContainerHeader>
      <LeftContainerBody>
        <BodyHeader>
          <span>{Text.annualTicketBalance}</span>
          <span onClick={() => setShowTicketList(!showTicketList)}>
            <img src={arrowDown} />
          </span>
        </BodyHeader>
        {showTicketList && (
          <BodyContent>
            {ticketValidityList.map((eachPassenger, i) => {
              return (
                <ValidityAccordion key={i} eachPassenger={eachPassenger} />
              );
            })}
          </BodyContent>
        )}
      </LeftContainerBody>
    </LeftContainer>
  );
};

export default PlanAJourneyLeftContainer;

const UserAvatarContainer = styled.div`
  display: none;
  @media only screen and (max-width: 768px) {
    display: block;
  }
`;
const UsernameAvatar = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;
const LeftContainer = styled.div`
  width: 45%;
  padding: 0 1.5rem;
  padding-top: 3rem;
  overflow-y: auto;
  height: calc(100vh - 10rem);
  &::-webkit-scrollbar {
    width: 0.875rem;
    -webkit-appearance: none;
  }

  &::-webkit-scrollbar-thumb {
    height: 3.625rem;
    border: 4px solid rgba(0, 0, 0, 0);
    background-clip: padding-box;
    border-radius: 0.625rem;
    background-color: ${Colors.brandOne};
  }
  @media only screen and (max-width: 768px) {
    width: 100%;
    height: auto;
    padding: 1rem;
    padding-bottom: 4rem;
    box-sizing: border-box;
  }
`;
const LeftContainerHeader = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  margin-bottom: 4rem;
  @media only screen and (max-width: 768px) {
    margin-bottom: 2rem;
  }
`;
const PassengerName = styled.div`
  font-size: 2.25rem;
  font-weight: 600;
  color: ${Colors.gray92};
  @media only screen and (max-width: 768px) {
    font-size: 1.5rem;
  }
`;
const PassengerWelcomeText = styled.div`
  font-size: 1rem;
  font-weight: 500;
  color: ${Colors.gray52Opcaity60};
  @media only screen and (max-width: 768px) {
    font-size: 0.75rem;
  }
`;
const BodyHeader = styled.div`
  font-weight: 600;
  font-size: 1.25rem;
  color: ${Colors.white};
  display: flex;
  justify-content: space-between;
  align-items: center;
  > span > img {
    display: none;
  }
  @media only screen and (max-width: 768px) {
    > span > img {
      display: block;
    }
  }
`;
const BodyContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding-top: 2.125rem;
  padding-right: 1rem;
  gap: 3.125rem;
  @media only screen and (max-width: 768px) {
    gap: 1.5rem;
  }
`;
const LeftContainerBody = styled.div``;
const LeftDisclaimer = styled.div`
  margin-top: 1.25rem;
`;
